import { combineReducers } from 'redux';
import { createAction, handleActions } from 'redux-actions';
import sortBy from 'lodash.sortby';

import { fetchCountries, fetchStates } from '@general/api/addressAPI';
import {
    fetchFunds,
    // fetchFoundationDonationSubscription,
    insertFoundationDonation,
    insertFoundationDonationCart,
} from '@general/api/fundsAPI';
import { getNewAddress } from '@general/entities/address';
import mapFunds from '../helpers/mapFunds';

import {
    // Memer Set
    doMemberSet,

    // Member Fetch
    initMemberFetch,
    receiveMemberFetch,
    errorMemberFetch,
    finishMemberFetch,

    // Member Insert
    initMemberInsert,
    receiveMemberInsert,
    errorMemberInsert,
    finishMemberInsert,

    // Member Update
    initMemberUpdate,
    receiveMemberUpdate,
    errorMemberUpdate,
    finishMemberUpdate,

    // Member Address Update
    initMemberAddressUpdate,
    receiveMemberAddressUpdate,
    finishMemberAddressUpdate,
} from '../../../_shared-react/redux/actions/memberActions';

// -----------------------------
// Action Types
// -----------------------------

// Error
const doErrorSet = createAction('SET_ERROR_DO');

// Loading
const doLoadingSet = createAction('SET_LOADING_DO');

// Address
const doCurrentAddressSet = createAction('SET_CURRENT_ADDRESS_DO');
const receiveAddressUpdate = createAction('UPDATE_ADDRESS_RECEIVE');

// Country
const initCountriesFetch = createAction('FETCH_COUNTRIES_INIT');
const requestCountriesFetch = createAction('FETCH_COUNTRIES_REQUEST');
const receiveCountriesFetch = createAction('FETCH_COUNTRIES_RECEIVE');
const errorCountriesFetch = createAction('FETCH_COUNTRIES_ERROR');
const finishCountriesFetch = createAction('FETCH_COUNTRIES_FINISH');

// State
const initStatesFetch = createAction('FETCH_STATES_INIT');
const requestStatesFetch = createAction('FETCH_STATES_REQUEST');
const receiveStatesFetch = createAction('FETCH_STATES_RECEIVE');
const errorStatesFetch = createAction('FETCH_STATES_ERROR');
const finishStatesFetch = createAction('FETCH_STATES_FINISH');

// Funds
const initFundsFetch = createAction('FETCH_FUNDS_INIT');
const requestFundsFetch = createAction('FETCH_FUNDS_REQUEST');
const receiveFundsFetch = createAction('FETCH_FUNDS_RECEIVE');
const errorFundsFetch = createAction('FETCH_FUNDS_ERROR');
const finishFundsFetch = createAction('FETCH_FUNDS_FINISH');

// // FoundationDonation Subscription Fetch
// const initFoundationDonationSubscriptionFetch = createAction('FETCH_FOUNDATIONDONATION_SUBSCRIPTION_INIT');
// const requestFoundationDonationSubscriptionFetch = createAction('FETCH_FOUNDATIONDONATION_SUBSCRIPTION_REQUEST');
// const receiveFoundationDonationSubscriptionFetch = createAction('FETCH_FOUNDATIONDONATION_SUBSCRIPTION_RECEIVE');
// const errorFoundationDonationSubscriptionFetch = createAction('FETCH_FOUNDATIONDONATION_SUBSCRIPTION_ERROR');
// const finishFoundationDonationSubscriptionFetch = createAction('FETCH_FOUNDATIONDONATION_SUBSCRIPTION_FINISH');

// FoundationDonation Insert
const initFoundationDonationInsert = createAction('INSERT_FOUNDATIONDONATION_INIT');
const requestFoundationDonationInsert = createAction('INSERT_FOUNDATIONDONATION_REQUEST');
const receiveFoundationDonationInsert = createAction('INSERT_FOUNDATIONDONATION_RECEIVE');
const errorFoundationDonationInsert = createAction('INSERT_FOUNDATIONDONATION_ERROR');
const finishFoundationDonationInsert = createAction('INSERT_FOUNDATIONDONATION_FINISH');

// FoundationDonation Cart Insert
const initFoundationDonationCartInsert = createAction('INSERT_FOUNDATIONDONATIONCART_INIT');
const requestFoundationDonationCartInsert = createAction('INSERT_FOUNDATIONDONATIONCART_REQUEST');
const receiveFoundationDonationCartInsert = createAction('INSERT_FOUNDATIONDONATIONCART_RECEIVE');
const errorFoundationDonationCartInsert = createAction('INSERT_FOUNDATIONDONATIONCART_ERROR');
const finishFoundationDonationCartInsert = createAction('INSERT_FOUNDATIONDONATIONCART_FINISH');

// -----------------------------
// Action Dispatch
// -----------------------------

// Error
const dispatchErrorSet = errorMessage => dispatch => {
    dispatch(doErrorSet(errorMessage));
};

// Error
const dispatchLoadingSet = updatedLoadingState => dispatch => {
    dispatch(doLoadingSet(updatedLoadingState));
};

// Country
const dispatchCountriesFetch = () => async dispatch => {
    dispatch(initCountriesFetch());
    dispatch(requestCountriesFetch());

    try {
        const response = await fetchCountries();
        const {
            data: { data },
        } = response;

        dispatch(receiveCountriesFetch(data));
        return data;
    } catch (error) {
        dispatch(errorCountriesFetch(error.message));
        throw new Error(error);
    } finally {
        dispatch(finishCountriesFetch());
    }
};

// State
const dispatchStatesFetch = () => async dispatch => {
    dispatch(initStatesFetch());
    dispatch(requestStatesFetch());

    try {
        const response = await fetchStates();
        const {
            data: { data },
        } = response;

        dispatch(receiveStatesFetch(data));
        return data;
    } catch (error) {
        dispatch(errorStatesFetch(error.message));
        throw new Error(error);
    } finally {
        dispatch(finishStatesFetch());
    }
};

// Funds
const dispatchFundsFetch = () => async dispatch => {
    dispatch(initFundsFetch());
    dispatch(requestFundsFetch());

    try {
        const response = await fetchFunds();
        const {
            data: { data },
        } = response;

        const mappedFunds = mapFunds(data);
        dispatch(receiveFundsFetch(mappedFunds));
        return mappedFunds;
    } catch (error) {
        dispatch(errorFundsFetch(error.message));
        throw new Error(error);
    } finally {
        dispatch(finishFundsFetch());
    }
};

// // FoundationDonation Stripe Subscription
// const dispatchFoundationDonationSubscriptionFetch = ({ memberId, fundCode, amount }) => async dispatch => {
//     dispatch(initFoundationDonationSubscriptionFetch());
//     dispatch(requestFoundationDonationSubscriptionFetch());

//     try {
//         const response = await fetchFoundationDonationSubscription({ memberId, fundCode, amount });
//         const {
//             data: { data },
//         } = response;

//         dispatch(receiveFoundationDonationSubscriptionFetch(data));
//         return data;
//     } catch (error) {
//         dispatch(errorFoundationDonationSubscriptionFetch(error.message));
//         throw new Error(error);
//     } finally {
//         dispatch(finishFoundationDonationSubscriptionFetch());
//     }
// };

// FoundationDonation
const dispatchFoundationDonationInsert = values => async dispatch => {
    dispatch(initFoundationDonationInsert());
    dispatch(requestFoundationDonationInsert());

    try {
        const response = await insertFoundationDonation(values);
        const {
            data: { data },
        } = response;

        dispatch(receiveFoundationDonationInsert(data));
        return data;
    } catch (error) {
        dispatch(errorFoundationDonationInsert(error.message));
        throw new Error(error);
    } finally {
        dispatch(finishFoundationDonationInsert());
    }
};

// FoundationDonation Cart
const dispatchFoundationDonationCartInsert = (cartID, values) => async dispatch => {
    dispatch(initFoundationDonationCartInsert());
    dispatch(requestFoundationDonationCartInsert());

    try {
        const response = await insertFoundationDonationCart(cartID, values);
        const {
            data: { data },
        } = response;

        dispatch(receiveFoundationDonationCartInsert(data));
        return data;
    } catch (error) {
        dispatch(errorFoundationDonationCartInsert(error.message));
        throw new Error(error);
    } finally {
        dispatch(finishFoundationDonationCartInsert());
    }
};

// -----------------------------
// Reducers
// -----------------------------

// Member
const member = handleActions(
    {
        [doMemberSet]: (state, action) => action.payload,
        [receiveMemberFetch](state, action) {
            return action.payload;
        },
        [receiveMemberInsert](state, action) {
            return action.payload;
        },
        [receiveMemberUpdate](state, action) {
            return action.payload;
        },
    },
    null
);

// Address
const currentAddress = handleActions(
    {
        [receiveMemberFetch](state, action) {
            return action.payload.addresses.find(address => address.purpose === 'main') || getNewAddress();
        },
        [receiveMemberInsert](state, action) {
            return action.payload.addresses.find(address => address.purpose === 'main') || getNewAddress();
        },
        [receiveMemberAddressUpdate](state, action) {
            const mainAddress = action.payload.addresses.find(address => address.purpose === 'main') || getNewAddress();
            const newState = { ...mainAddress };

            if (!newState.address_1 && state?.address_1) {
                newState.address_1 = state.address_1;
            }

            return newState;
        },
        [receiveAddressUpdate](state, { payload }) {
            return payload.addresses.find(address => address.purpose === 'main') || getNewAddress();
        },
        [doCurrentAddressSet](state, { payload }) {
            return payload;
        },
    },
    null
);

// Country
const countries = handleActions(
    {
        [receiveCountriesFetch](state, { payload }) {
            return sortBy(payload, ['name']);
        },
    },
    []
);

// State
const states = handleActions(
    {
        [receiveStatesFetch](state, { payload }) {
            return sortBy(payload, ['country', 'name']);
        },
    },
    []
);

// Funds
const funds = handleActions(
    {
        [receiveFundsFetch](state, { payload }) {
            return sortBy(payload, ['name']);
        },
    },
    []
);

// Error
const error = handleActions(
    {
        [doErrorSet](state, action) {
            return action.payload;
        },
        [initMemberFetch]() {
            return null;
        },
        [initMemberInsert]() {
            return null;
        },
        [errorMemberFetch](state, action) {
            return action.payload;
        },
        [errorMemberInsert](state, action) {
            return action.payload;
        },
        [errorFoundationDonationInsert](state, action) {
            return action.payload;
        },
        // [errorFoundationDonationSubscriptionFetch](state, action) {
        //     return action.payload;
        // },
    },
    null
);

// Loading
const loading = handleActions(
    {
        [doLoadingSet](state, { payload }) {
            return payload;
        },
        [initMemberFetch]() {
            return true;
        },
        [initMemberInsert]() {
            return true;
        },
        [initMemberUpdate]() {
            return true;
        },
        [initMemberAddressUpdate]() {
            return true;
        },
        [initFoundationDonationInsert]() {
            return true;
        },
        [initFoundationDonationCartInsert]() {
            return true;
        },
        // [initFoundationDonationSubscriptionFetch]() {
        //     return true;
        // },
        [finishMemberFetch]() {
            return false;
        },
        [finishMemberInsert]() {
            return false;
        },
        [finishMemberUpdate]() {
            return false;
        },
        [finishMemberAddressUpdate]() {
            return false;
        },
        [finishFoundationDonationInsert]() {
            return false;
        },
        [finishFoundationDonationCartInsert]() {
            return false;
        },
        // [finishFoundationDonationSubscriptionFetch]() {
        //     return false;
        // },
    },
    false
);

const rootReducer = combineReducers({
    error,
    loading,
    member,
    currentAddress,
    countries,
    states,
    funds,
});

// -----------------------------
// Selectors
// -----------------------------

const getErrorState = state => state.FoundationDonation.error;
const getLoadingState = state => state.FoundationDonation.loading;
const getMemberState = state => state.FoundationDonation.member;
const getCurrentAddressState = state => state.FoundationDonation.currentAddress;
const getCountriesState = state => state.FoundationDonation.countries;
const getStatesState = state => state.FoundationDonation.states;
const getFundsState = state => state.FoundationDonation.funds;

// -----------------------------
// Exports
// -----------------------------

export {
    rootReducer,
    dispatchErrorSet,
    dispatchLoadingSet,
    dispatchCountriesFetch,
    dispatchStatesFetch,
    dispatchFundsFetch,
    dispatchFoundationDonationInsert,
    dispatchFoundationDonationCartInsert,
    // dispatchFoundationDonationSubscriptionFetch,
    getErrorState,
    getLoadingState,
    getMemberState,
    getCurrentAddressState,
    getCountriesState,
    getStatesState,
    getFundsState,
};
